export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_12.adf037c9.png";